import { useAutoshipSubscriptionsQuery } from '@libs/common-next';

import { getEarliestSubscriptionForSku } from '@/entities/autoship-customer-subscriptions';
import { useProduct } from '@/entities/product';

import { formatDeliveryDate } from '../lib';

export type UseAutoshipSubscriptionResult = {
    isReady: boolean;
    nextDeliveryDate: string | null;
    subscriptionOrderId: string | null;
    isSubscribed: boolean;
    isError: boolean;
};

export const useAutoshipSubscription = (): UseAutoshipSubscriptionResult => {
    const { product, isLoading: isProductLoading } = useProduct();
    const { data: autoshipData, isLoading: isAutoshipLoading, isError } = useAutoshipSubscriptionsQuery();

    const isReady = !isProductLoading && !isAutoshipLoading && !isError;

    const activeSubscriptions = autoshipData?.data?.activeSubscriptions;
    const sku = product?.sku;

    const earliestSubscription =
        activeSubscriptions && sku ? getEarliestSubscriptionForSku(activeSubscriptions, sku) : null;

    const nextDeliveryDate = earliestSubscription ? formatDeliveryDate(earliestSubscription.nextDeliveryDate) : null;
    const subscriptionOrderId = earliestSubscription?.orderId ?? null;

    return {
        isReady,
        isError,
        nextDeliveryDate,
        subscriptionOrderId,
        isSubscribed: nextDeliveryDate !== null,
    };
};
